const FileViewer = ({ files }) => {
    if (!files || files.length === 0) return null;
    return (
        <div className="mt-4">
            {/* File tabs */}


            {/* PDF preview */}
            <div className="border rounded-md overflow-hidden h-[500px]">
                <iframe
                    src={files}
                    width="100%"
                    height="100%"
                    style={{ border: 'none' }}
                    title='file'
                />
            </div>
        </div>
    );
};

export default FileViewer;